import { ResolveButton } from './ResolveButton'
import { PatientSearchModal } from 'features/Schedule/pages/components/ManageAppointment/PatientSearchModal/PatientSearchModal'
import {
  useResolvePrescriptionMutation,
  type IDistinctPatientMappingItem,
} from 'features/Profile/features/Prescriptions/patient-data.api'
import { useToggle } from 'react-use'
import { type IPatient } from 'features/Patients/interfaces/IPatient'
import { useNotification } from 'app/providers/notification/NotificationProvider'
import { useParams } from 'react-router'
import { ALERT_CONSTANTS } from 'common/constants/alertConstants'

type Props = {
  item: IDistinctPatientMappingItem
}

export const MapPatientManuallyModal = ({ item }: Props) => {
  const [isOpen, toggleOpen] = useToggle(false)
  const { siteId } = useParams()

  const [resolvePrescription, { isLoading: isResolvingPrescription }] =
    useResolvePrescriptionMutation({ fixedCacheKey: 'ResolvePrescription' })

  const { setNotification } = useNotification()
  const handleConfirm = async (patient: IPatient) => {
    try {
      await resolvePrescription({
        pid: patient.pid,
        first_name: item.first_name,
        last_name: item.last_name,
        siteId: siteId as string,
      }).unwrap()
    } catch (e: any) {
      setNotification({
        title: 'Error',
        description: e?.data?.[0] || e?.message || 'Failed to resolve prescription',
        type: ALERT_CONSTANTS.ERROR,
      })
    }
  }
  return (
    <>
      <ResolveButton isLoading={isResolvingPrescription} handleClick={toggleOpen} />
      <PatientSearchModal handleConfirm={handleConfirm} isOpen={isOpen} onClose={toggleOpen} />
    </>
  )
}
